import { useMemo } from "react";
import PropTypes from "prop-types";

const SORT_ICONS = {
  none: "pi pi-sort-alt hover:text-main cursor-pointer",
  asc: "pi pi-sort-amount-up-alt text-main hover:text-main-l cursor-pointer",
  desc: "pi pi-sort-amount-down text-main hover:text-main-l cursor-pointer",
};

export default function ModuleTableSort({
  field,
  sortType,
  sortField,
  setSortField,
  rawTbData,
  tbData,
  setTbData,
}) {
  const nowIcon = useMemo(
    () => sortField.find((item) => item.field === field)?.icon ?? null,
    [field, sortField],
  );

  const getNextIcon = () => {
    if (nowIcon === null) return 1;
    if (nowIcon === 1) return 2;
    return null;
  };
  const getIconClassName = () => {
    if (nowIcon === null) return SORT_ICONS.none;
    if (nowIcon === 1) return SORT_ICONS.asc;
    return SORT_ICONS.desc;
  };
  const nextIcon = getNextIcon();
  const iconClassName = getIconClassName();

  const sortChange = (icon) => {
    let tempField = [...sortField];
    if (icon === null) {
      tempField = [];
    } else {
      tempField = [
        {
          field,
          icon,
          type: sortType,
        },
      ];
    }
    setSortField(tempField);

    let tempData = [...tbData];
    tempData.sort(function (pre, next) {
      let flag = 0;
      tempField.forEach((item) => {
        let start = item.icon === 1 ? pre : next,
          end = item.icon === 1 ? next : pre;
        if (item.type === "string") {
          flag = start[item.field].localeCompare(end[item.field]);
        } else if (item.type === "number") {
          let limit = item.icon === 1 ? 99999999 : -99999999;
          flag = (start[item.field] ?? limit) - (end[item.field] ?? limit);
          if (Number.isNaN(flag)) flag = -1;
        }
      });
      return flag;
    });
    if (tempField.length === 0) tempData = rawTbData;
    setTbData(tempData);
  };

  return (
    <div className="ml-2">
      <button
        type="button"
        className="inline-flex border-none bg-transparent p-0"
        onClick={() => sortChange(nextIcon)}
      >
        <i className={iconClassName}></i>
      </button>
    </div>
  );
}

ModuleTableSort.propTypes = {
  field: PropTypes.string,
  sortType: PropTypes.string,
  sortField: PropTypes.arrayOf(
    PropTypes.shape({
      field: PropTypes.string,
      icon: PropTypes.number,
      type: PropTypes.string,
    }),
  ),
  setSortField: PropTypes.func.isRequired,
  rawTbData: PropTypes.arrayOf(PropTypes.object),
  tbData: PropTypes.arrayOf(PropTypes.object),
  setTbData: PropTypes.func.isRequired,
};
